export default "__VITE_ASSET__BP07c9Cs__"